import { Component, Input } from '@angular/core';

import { AuthService } from '@core';
import { SSODrivers } from '@core/authentication/sso/sso.type';
import { environment } from '@env/environment';
import { MaterialModule } from 'app/material.module';

import { AuthRedirectService } from '@core/authentication/auth-redirect.service';
import { SpinnerComponent } from '@shared/components/spinner/spinner.component';
import { CommonService } from '@shared/services/common.service';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss'],
  standalone: true,
  imports: [MaterialModule, SpinnerComponent],
})
export class SsoComponent {
  @Input() public redirectUrl: string | null = null;

  protected waitingForSSO = false;
  protected showOkta = environment.brand !== 'takeda';

  constructor(
    private auth: AuthService,
    private commonService: CommonService,
    private authRedirectService: AuthRedirectService
  ) {}

  loginViaSSO(driver: SSODrivers) {
    this.waitingForSSO = true;
    this.authRedirectService.save(this.redirectUrl);
    this.auth.redirectToLoginSSO(driver)?.subscribe({
      next: url => {
        if (url) {
          window.location.href = url.authUrl;
        }
      },
      error: () => {
        this.waitingForSSO = false;
        this.commonService.openErrorSnackBar('Failed to login via SSO');
      },
      complete: () => undefined,
    });
  }
}
